// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"139":"oss2026docs","407":"panel","884":"admin","962":"home"}[chunkId] || chunkId) + "." + {"139":"e82769a2","407":"fa3dbba3","884":"ca9bf4d3","928":"3c1075c5","962":"1fb96fbe"}[chunkId] + ".js";
};